import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ICall, Call } from "@/models/call.entity";

export const CallDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<ICall> {
  protected mapEntity(entity: ICall): ICall {
    return new Call(entity);
  }

  getIdentifier(entity: ICall): string {
    return entity.id;
  }
})();
